<template>
    <div>
        <v-main>
            <skrg_overview/>
        </v-main>
        <navBar title="Ares - Reference data" :home="true" type="referencedata" />
    </div>
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";

    import skrg_overview from '@/components/syst/ref/skrg/skrg_overview.vue'

    export default {
        components: {
            navBar,
            skrg_overview,
        },    
        data() {
            return {
            }
        },    
        methods: {     
        }
    }
</script>

<style scoped> 

</style>